import { Outlet } from "react-router-dom";
import { ListingFlowProvider } from "@/contexts/ListingFlowContext";

export default function CreateListingLayout() {
  return (
    <ListingFlowProvider>
      <Outlet />
    </ListingFlowProvider>
  );
}
